import { PermissionRepository } from './domain/repositories/PermissionRepository'
import { permissionDatasourceAdapter } from './external/datasource/permissionDatasourceAdapter'
import { permissionRepositoryAdapter } from './infra/repositories/permissionRepositoryAdapter'

export const permissionInstance = Permission(
  permissionRepositoryAdapter(permissionDatasourceAdapter)
)

export default function Permission(permissionRepository: PermissionRepository) {
  return {
    async getUserPermissions(personaId: string) {
      return await permissionRepository.getUserPermissions(personaId)
    }
  }
}
